<template>
  <fragment>
        <div class="card-header row">
          <div class="col-10">
            <h4 class="page-title">Elenco chiamate</h4>
          </div>
          <div class="col-2 text-right">
            <button
              title="Aggiorna"
              type="button"
              class="btn btn-round btn-primary-rgba"
              @click="loaddata"
            >
              <i class="feather icon-refresh-cw"></i>
            </button>
          </div>
        </div>
  <noresult v-if="entity.length==0" />
    <div class="ecom-notification-box"  v-if="entity.length>0 ">
                                            <ul class="list-unstyled">
                                                <li class="media"  v-for="(item,index) in entity" v-bind:key="index">
                                                    <span :class="getClass(item)">
                                                      <i class="feather icon-phone-incoming" v-if="item.type=='IN'"></i>
                                              <i class="feather icon-phone-outgoing"  v-if="item.type=='OUT'"></i>
                                              </span>
                                                    <div class="media-body">
                                                        <h5 class="action-title" v-if="item.type=='IN'">Chiamata in ingresso (<i class="feather icon-clock"></i> {{item.duration | duration}})</h5>
                                                        <h5 class="action-title" v-if="item.type=='OUT'">Chiamata in uscita  (<i class="feather icon-clock"></i> {{item.duration | duration}})</h5>
                                                        <p class="my-3"> Chiamata da <strong>{{item.source}}</strong> ({{item.fromName}}) a <strong>{{item.destination}}</strong>  ({{item.toName}})</p>
                                                        <p><span class="badge badge-danger-inverse" v-if="item.disposition=='BUSY'">Occupato</span>
                                                        <p><span class="badge badge-danger-inverse"  v-if="item.disposition=='NO ANSWER'">Senza risposta</span>
                                                        <span class="badge badge-info-inverse"  v-if="item.disposition=='ANSWERED'">Risposta</span>
                                                        <span class="timing">{{item.start | formatFullDate}} - {{item.end | formatFullDate}} </span></p>
                                                    </div>
                                                </li>
                                               
                                            </ul>
                                        </div>
    
    
  </fragment>
</template>
<script>
import axios from "axios";
export default {
  name: "callList",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      entity: [],
      descriptions:[]
    };
  },
  methods: {
    getClass(item) {
      if(item.disposition =="ANSWERED")
     return "mr-3 action-icon badge badge-success-inverse";

      return "mr-3 action-icon badge badge-danger-inverse";
    },
    loaddata(){
      let me = this;
  axios.get(`call/${me.value}`).then((response) => {
        me.entity = response.data;
      });

    }
  },

  beforeMount() {
   setTimeout(this.loaddata,300);
   
  },
};
</script>
